import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Add Antenna route override
 *
 * @namespace routes.DeviceAntennasFormAdd
 * @type {TmrRoute}
 */
let addRoute = {
  name: 'devices.antennas.add',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.RfidAntenna.edit`],
}

/**
 * Edit Antenna route override
 *
 * @namespace routes.DeviceAntennasFormEdit
 * @type {TmrRoute}
 */
let editRoute = {
  name: 'devices.antennas.view.edit',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.RfidAntenna.edit`],
}

/**
 * Delete Antenna route override
 *
 * @namespace routes.DeviceAntennasDelete
 * @type {TmrRoute}
 */
let deleteRoute = {
  name: 'devices.antennas.view.delete',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.RfidAntenna.edit`],
}

export const routes = [addRoute, editRoute, deleteRoute]

/**
 * Add/Edit Antenna form component.
 *
 * @type {ngComponent}
 * @prop {TmrResource} resource
 * @prop {string} toast
 */
export const tmrAdminAntennaForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAntennaFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminAntennaForm}.
 *
 * @type {ngController}
 */
export class tmrAntennaFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    Zone,
    RfidReader
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { Zone, RfidReader })
  }

  /** Query to get stock zones for md-autocomplete */
  getZones(description) {
    return this.Zone.query({ description, zoneType: 'STOCK' }).$promise
  }

  /** Query to get rfidReaders for md-autocomplete */
  getRfidReader(value) {
    return this.RfidReader.search({ value }).$promise
  }
}
